export default __webpack_public_path__ + "static/media/mirror.eba37eb3.png";